import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import SpousalProfileViewModel from '../SpousalProfile/SpousalProfileViewModel'

interface Props {
  vm: SpousalProfileViewModel
}

export default observer(function SpousalProfile({ vm }: Props) {
  if (!vm.profile) {
    return <></>
  }

  return (
    <div>
      <Section
        title="Spousal Information"
        bordered
        loading={vm.activate.pending}
      >
        <SectionItem
          label="Name"
          value={vm.profile?.personalInfo?.fullName}
          isSensitive
        />

        <SectionItem
          label="Date of birth"
          value={vm.profile?.personalInfo?.dateOfBirth}
          isSensitive
        />

        <SectionItem
          label="Occupation"
          value={vm.profile?.occupation}
          isSensitive
        />

        {vm.profile?.contactInfo?.email && (
          /* For spouses we only really care about the e-mail. The backend supports collecting
            the whole contact info, but in practice only the email is used. This was done to maintain
            consistency in the API shapes, and in case they change their minds about additional contact
            info in the future. */
          <SectionItem
            label="Email address"
            value={vm.profile?.contactInfo?.email}
            isSensitive
          />
        )}

        <SectionItem
          label="SSN or ITIN"
          value={vm.profile?.personalInfo?.personalTaxpayerIdentificationNumber}
          maskedValue={
            vm.profile?.personalInfo
              ?.personalTaxpayerIdentificationNumberDisplay
          }
          isSensitive
        />
      </Section>
    </div>
  )
})
